<template>
  <PublicPopup
    ref="PopupRef"
    background="transparent"
    :border-size="0"
    :padding="0"
    @close="emit('close')"
  >
    <template #content>
      <div class="images-popup">
        <van-swipe class="swipe-list" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="e in list" :key="e.id" class="swipe-item">
            <div class="swipe-item-images-box">
              <img class="swipe-item-images" :src="e.phone_img" @click="jumpUrl(e.redirect_url)" />
            </div>
          </van-swipe-item>
        </van-swipe>

        <CheckboxPublic type="images" />
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { activityPopupImg } from '@/api/user'
import { useUserStore } from '@/stores'

const route = useRoute()

const userStore = useUserStore()
const hadToken = computed(() => {
  return !!userStore.userInfo.token
})

const ImagesPopupChecked = ref(window.localStorage.ImagesPopupChecked || 'null')

const PopupRef = ref(null)
const open = () => {
  if (ImagesPopupChecked.value === 'checked') return false

  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const list = ref([])
const getList = async () => {
  list.value = []

  const { data } = await activityPopupImg()
  const resList = data

  if (resList && resList.length > 0) {
    list.value = resList

    nextTick(() => {
      if (route.name === 'Home') {
        open()
      }
    })
  }
}
const jumpUrl = (url) => {
  if (url && url !== undefined) {
    window.open(url)
  }
}
const emit = defineEmits(['close'])

defineExpose({
  getList,
  open,
})
</script>

<style lang="scss" scoped>
.images-popup {
  width: 85vw;

  .swipe-list {
    width: 100%;

    .swipe-item {
      margin: 0 auto;
      max-width: 300px;

      .swipe-item-images-box {
        width: 300px;

        .swipe-item-images {
          width: 100%;
          border: 1px solid var(--popup-primary-border__primary);
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
